import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Optional Bearer token (cookies are primary)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("modav_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Prod write-protection: backend requires this header on DELETE requests
  // when MODAV_ENV=production. Sending it on every request is safe; the
  // backend only checks it on DELETE.
  config.headers["X-Modav-Confirm"] = "production-write";
  return config;
});

export default api;
